import { create } from "zustand";
import { persist } from "zustand/middleware";

interface PinnedChatsState {
  /** En son sabitlenen en başta olacak şekilde sıralı sohbet id listesi */
  pinnedIds: string[];
  isPinned: (id: string) => boolean;
  togglePin: (id: string) => void;
  unpin: (id: string) => void;
}

/**
 * Sohbetleri sidebar'da üstte sabitleme (pin) tercihi.
 * Backend'de karşılığı olmadığı için sadece client-side / cihaza özel saklanır.
 */
const usePinnedChatsStore = create<PinnedChatsState>()(
  persist(
    (set, get) => ({
      pinnedIds: [],

      isPinned: (id: string) => get().pinnedIds.includes(id),

      togglePin: (id: string) =>
        set((state) => ({
          pinnedIds: state.pinnedIds.includes(id)
            ? state.pinnedIds.filter((pinnedId) => pinnedId !== id)
            : [id, ...state.pinnedIds],
        })),

      unpin: (id: string) =>
        set((state) => ({
          pinnedIds: state.pinnedIds.filter((pinnedId) => pinnedId !== id),
        })),
    }),
    {
      name: "pinned-chats-storage",
    }
  )
);

export default usePinnedChatsStore;
